import PersonalInfoAddressForm from './PersonalInfoAddressForm.component';

export default PersonalInfoAddressForm;
